export { default as ClassicProgressBar } from './ClassicProgressBar';
export type { Props as ClassicProgressBarProps } from './ClassicProgressBar';
